import Principal from '../Pages/Principal/Principal';
import ImagenDataView from '../Pages/ImagenesView/ImagenDataView';
import LeyendaDataView from '../Pages/LeyendasView/LeyendaDataView';
import { Route, Routes } from 'react-router-dom';
import EscoDrawer from '../Layout/EscoDrawer';
import { Login } from '@mui/icons-material';
import LeyendaImgDataView from '../Pages/LeyendaImgView/LeyendaImgDataView';
import LeyendaFirmaDataView from '../Pages/LeyendaFirmaView/LeyendaFirmaDataView';
import FdoImgDataView from '../Pages/FdoImgView/FdoImgDataView';
import ConfigMicroserviciosDataView from '../Pages/ConfigMicroservicios/ConfigMicroserviciosDataView';
import ConfigMicroserviciosParam from '../Pages/ConfigMicroservicios/ConfigMicroservicioParam';
import FrmParamsDataView from '../Pages/FrmParamsView/FrmParamsDataView';
import FrmParamsView from '../Pages/FrmParamsView/FrmParamsView';
import ConfigRutaReportServer from '../Pages/ConfigMicroservicios/ConfigRutaReportServer';
import Dashboard from '../Pages/Dashboard/Dashboard';

function Routers(props) {
    return (
        <EscoDrawer>
            <Routes>
                <Route path="/" element={<Principal />} />
                <Route path="/login" element={<Login />} />
                <Route path="/frmParams" element={<FrmParamsDataView />} />
                <Route path="/frmLeyen" element={<LeyendaDataView />} />
                <Route path="/frmLeyenImg" element={<LeyendaImgDataView />} />
                <Route path="/frmLeyenFirm" element={<LeyendaFirmaDataView />} />
                <Route path="/frmImgFnd" element={<FdoImgDataView />} />
                <Route path="/frmImg" element={<ImagenDataView />} />
                <Route path="/msvParams" element={<ConfigMicroserviciosDataView />} />
                <Route path="/msvParams/params" element={<ConfigMicroserviciosParam />} />
                <Route path="/frmParams/params" element={<FrmParamsView />} />
                <Route path="/msvRutaReportServer" element={<ConfigRutaReportServer />} />
                <Route path="/msvTableroDeServicios" element={<Dashboard />} />

            </Routes>
        </EscoDrawer>
    );
}

export default Routers;